module.exports = __webpack_public_path__ + "static/greendot-item-984e58f470a71ac710c78764ae35852e.png";